<template>
    <div class="app_container">
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">

                <el-form-item>
                    <el-input v-model="form.keyword" placeholder="请输入关键字" @keyup.enter.native="loadData"  :inline="true"></el-input>
                </el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>


            </el-form>
        </el-card>
        <el-card>

            <el-table :data="tableData" v-loading="!loading" >
                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <!--<el-table-column type="selection" width="55"></el-table-column>-->
                <!--<el-table-column label="编号" prop="serialNumber"></el-table-column>-->
                <el-table-column label="标题" prop="title"></el-table-column>
                <el-table-column label="巡检对象" prop="cmdb">
                    <template slot-scope="scope">
                        <el-button v-for="item in scope.row.cmdb" type="text" style="color: black">{{item.title}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="处理组" prop="handlerGroup"></el-table-column>
                <el-table-column label="处理人" prop="currentHandler"></el-table-column>
                <el-table-column label="创建时间" prop="createTime" width="140"></el-table-column>
                <el-table-column label="创建人" prop="createUser" ></el-table-column>
                <el-table-column label="巡检状态" prop="isInspect" >
                    <template slot-scope="scope">
                        <el-button type="text" style="color: black">{{scope.row.isInspect==true?'已巡检':'未巡检'}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <router-link :to="{path:'/inspectionTable',query:{callback:request,id:scope.row.id,type:'view',getDetailOrNot:true}}">
                            <el-button type="text">查看</el-button>
                        </router-link>
                        <el-button class="table-del-btn" type="text" @click="deleteRole(scope.row)" v-w-role="'ITSM-0238'">删除</el-button>

                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>

    </div>
</template>

<script>
    // import {statusLists} from './change.config'
    import services from "./inspection.service"
    export default {
        data() {
            return {
                form:{
                    keyword:"",
                    pageSize:10,
                    pageIndex:1,
                },
                total:null,
                tableData:[],
                inspectFormHeader:{},
                loading:true,

                ExportBtn:false,
            }
        },
        created() {

            this.request();
        },
        computed:{
            // dictionary(){
            //     return this.$store.state.dictionary;
            // },
            // changeStatus(){
            //     return this.dictionary.change_status;
            // }
        },
        methods: {
            // showRow(val){
            //     console.log(val);
            // },
            loadData(){
                this.form.pageIndex = 1;
                this.request();
            },
            request(){
                // // 获取列表数据
                // console.log(this.dictionary,'字典');
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                services.getRecordList(this.form).then(res => {

                    this.tableData = res.list;
                    this.inspectFormHeader={}
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = true;
                })
            },
            deleteRole(row){
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.deleteAgency({ id:row.id }).then(res => {
                        this.$message.success("删除成功");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            }
        }
    }
</script>

<style scoped>

</style>
